export const questionTranslations = {
    clientNumber: {
        label: 'Client Number',
        description: 'Clients ID in Portfol',
        invalidMessages: {
            format: 'Enter number between 1 and 3 digits in length.'
        }
    },
    businessName: {
        label: 'Business Name',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        tooltip: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    },
    dba: {
        label: 'DBA',
        description: 'Doing Business As',
        tooltip: ''
    },
    race: {
        label: 'Race'
    },
    clientRelationshipManager: {
        label: 'Client Relationship Manager'
    },
    nonProfit: {
        label: 'Non profit?'
    },
    monthFiscalYearEnds: {
        label: 'Month Fiscal Year Ends'
    },
    daysAfterFiscalYearEnd: {
        label: 'Days After Fiscal Year Ends that Report is Due'
    },
    businessType: {
        label: 'Type of Business'
    },
    yearEstablished: {
        label: 'Date Established'
    },
    ein: {
        label: 'EIN',
        invalidMessages: {
            format: 'Invalid format. EIN must be 9 digits in length.'
        }
    },
    orgForm: {
        label: 'Form of Organization'
    },
    activeLoan: {
        label: 'Active Loan on File?'
    },
    inDefault: {
        label: 'In Default?'
    },
    doNotContact: {
        label: 'Do not contact?'
    },
    okToContact: {
        label: 'Ok to contact?'
    },
    okToContactOrg: {
        label: 'Ok to contact?'
    },
    loanNumber: {
        label: 'Loan Number',
        description: 'The correct format should be 5 to 8 digits and should include 2 dashes (e.g. 12-34-56)',
        invalidMessages: {
            format: 'Invalid loan number format.'
        }
    },
    portfolContactId: {
        label: 'Portfol Contact ID'
    },
    loanAmount: {
        label: 'Approved Loan Amount'
    },
    loanBalance: {
        label: 'Current Loan Balance'
    },
    actualSettlementDate: {
        label: 'Actual Settlement Date'
    },
    effectiveTerminationDate: {
        label: 'Effective Termination Date'
    },
    groupFinancingTotal: {
        label: 'Group Financing Total'
    },
    closed: {
        label: 'Closed?'
    },
    loanOfficer: {
        label: 'Loan Officer'
    },
    percentOwnership: {
        label: 'Percent Ownership',
        checkbox: {
            label: 'Is owner?'
        }
    },
    suffix: {
        label: 'Suffix',
        placeholder: 'Eg. Junior (Jr), Senior (Sr)'
    },
    honorific: {
        label: 'Honorific',
        placeholder: 'Eg. Doctor (Dr), Professor (Prof)'
    },
    pronouns: {
        label: 'Pronouns',
        placeholder: 'Eg. They/them, he/him',
        tooltip:
            'If your pronouns are not listed, just type them into the field below and click on the `+ Create` button which appears.'
    },
    salutation: {
        label: 'Greeting / Salutation for Letter'
    },
    contactsModule: {
        label: 'Contacts'
    },
    firstName: {
        label: 'First Name'
    },
    middleInitial: {
        label: 'Middle Initial'
    },
    lastName: {
        label: 'Last Name'
    },
    jobTitle: {
        label: 'Job title'
    },
    primaryContact: {
        label: 'Primary Contact',
        nothingFound: "Couldn't find a contact by that name",
        description:
            'The individual assigned as primary contact for your organization will function as the primary administrator for your organization profile on this platform.'
    },
    orgStatus: {
        label: 'Status'
    },
    childOrgs: {
        label: 'Child Organizations'
    },
    loanCorp: {
        label: 'Loan Corp'
    },
    loanPartner: {
        label: 'Loan Partner'
    },
    loanPartnerShare: {
        label: 'Loan Partner Share',
        placeholder: ' %'
    },
    fromChildOrg: {
        label: 'From child organization',
        description: 'The Client Number (Portfol ID) of the child organization which this loan is inherited from'
    },
    financialContact: {
        label: 'Financials Contact',
        nothingFound: "Couldn't find a contact by that name",
        description:
            'The individual assigned as financial contact will additionally be provisioned access to this platform and will be included in all correspondence regarding upcoming financial data surveys.',
        tooltip: 'In some cases this may be the same individual as the primary contact.'
    },
    email: {
        label: 'E-mail Address',
        invalidMessages: {
            format: 'Invalid email.'
        }
    },
    secondaryEmail: {
        label: 'Secondary E-mail Address',
        invalidMessages: {
            format: 'Invalid email.'
        }
    },
    phone: {
        label: 'Phone',
        invalidMessages: {
            format: 'Invalid phone number.',
            extWithoutNum: 'Extension provided with no phone number.'
        }
    },
    homePhone: {
        label: 'Home Phone',
        invalidMessages: {
            format: 'Invalid phone number.'
        }
    },
    mobilePhone: {
        label: 'Mobile Phone',
        invalidMessages: {
            format: 'Invalid phone number.'
        }
    },
    orgName: {
        label: 'Organization Name'
    },
    gender: {
        label: 'Gender'
    },
    raceEthnicity: {
        label: 'Race / Ethnicity',
        description: 'Select all that apply'
    },
    veteran: {
        label: 'Veteran?'
    },
    disabled: {
        label: 'Disabled?'
    },
    owner: {
        label: 'Is owner?'
    },
    businessLegalStructure: {
        label: 'How is your business legally structured?'
    },
    operationStartDate: {
        label: 'When did your business begin operating?'
    },
    businessDetail: {
        label: 'Please describe your business in detail.'
    },
    stillRunning: {
        label: 'Are you still running your business?'
    },
    businessCloseDate: {
        label: 'If no, when did your business close?'
    },
    businessCloseReason: {
        label: 'If no, why did you close your business?'
    },
    businessCloseReasonDescription: {
        label: 'If you selected "other," please describe.'
    },
    lastDayFiscalYeah: {
        label: 'What is the last day of your fiscal year?'
    },
    ownerCount: {
        label: 'Please indicate owners, including yourself, for your organization below.',
        description:
            'We consider owners as anyone with at least a 20% stake. If your business structure does not have owners, please answer instead for your executive leadership team.'
    },
    executiveCount: {
        label: 'Please indicate executive team members, including yourself, for your organization below.'
    },
    goalForLoan: {
        label: 'When you requested financing with CIC, which of the following best describes the goal you had in mind?'
    },
    whichFinancialProblem: {
        label: 'What type of urgent or upcoming financial problem needs (or needed) solving?'
    },
    describeFinancialProblem: {
        label: 'If you selected "other" or a "non-financial problem," please describe.'
    },
    previousLoanApplication: {
        label: 'Previous to applying for a loan/credit with CIC, had you applied for a loan/credit elsewhere?'
    },
    wereExpectationsMet: {
        label: 'Overall, how well were your expectations met with your loan/credit experiences <highlight><i>elsewhere</i></highlight>?'
    },
    experienceCompare: {
        label: 'How did your experience applying for a loan/credit <highlight><i>with CIC</i></highlight> compare with your other experiences?',
        description: 'My experience with CIC was…'
    },
    experienceCompareDescription: {
        label: 'Would you like to further elaborate on your previous question?'
    },
    reasonForLoanApproval: {
        label: 'What are some strengths that you believe helped with obtaining your CIC loan/credit?',
        description: 'Select all that apply.'
    },
    extentOfGoalsAccomplished: {
        label: 'When you applied for your loan/credit with CIC, the primary reason you listed was _________.  To what extent did you accomplish this goal?'
    },
    accomplishedOtherGoals: {
        label: 'Did your loan/credit with CIC help accomplish any other goal(s)?'
    },
    otherGoalsAccomplished: {
        label: 'If so, what other goal(s) did you accomplish with your loan/credit with CIC?'
    },
    extentGoalsAccomplishedByLoan: {
        label: 'Overall, to what extent did your loan/credit with CIC help with accomplishing your goal(s)?'
    },
    revenueSatisfaction: {
        label: 'When you received your loan/credit from CIC, your annual gross income was _______.  How satisfied are you with the changes in revenue since that time?'
    },
    expectationMet: {
        label: 'Overall, how well has CIC met your expectations?'
    },
    suggestionsForCIC: {
        label: 'What, if anything, could CIC do to better meet your expectations?'
    },
    challengesDescription: {
        label: 'Beyond financing, are there challenges you face as a business owner that you could use help with at this time?  If so, please explain.'
    },
    likelyOtherCapitalSource: {
        label: 'If you were to need additional capital (loan, credit, etc.) in the future, where are you most likely to go?'
    },
    grossSalesIncome: {
        label: "What was your business's annual gross sales/income between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?",
        description: 'If your business was not operating during this period, please input $0'
    },
    businessPerformance: {
        label: 'How did your business perform financially between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?'
    },
    businessPerformanceMeetExpectations: {
        label: "How did your business' financial performance between {{it.targetPeriod.start}} and {{it.targetPeriod.end}} meet your expectations?"
    },
    pleaseExplainPreviousAnswer: {
        label: 'Please elaborate on your answer above. What specific financial expectations did you have and in what way(s) did your business meet or not meet them?'
    },
    employeeCount: {
        label: 'Not counting yourself and not counting contractors, how many paid employees did your business have at the end of {{it.targetPeriod.end}}?',
        description: 'Employees are defined as those who receive a W-2 tax form from the business.',
        placeholder: 'Number of employees'
    },
    offeredHealthInsuranceCount: {
        label: 'How many were offered health insurance between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?',
        // label: 'Of those {{it.employeeCount}} employees, how many were offered health insurance between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?'
        placeholder: 'Number of employees'
    },
    offeredPtoCount: {
        label: 'How many were offered paid time off between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?',
        // label: 'Of those {{it.employeeCount}} employees, how many were offered paid time off between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?'
        placeholder: 'Number of employees'
    },
    offeredRetirementPlanCount: {
        label: 'How many were offered a retirement plan between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?',
        // label: 'Of those {{it.employeeCount}} employees, how many were offered a retirement plan between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?'
        placeholder: 'Number of employees'
    },
    offeredRaiseCount: {
        label: 'How many were offered a raise between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?',
        // label: 'Of those {{it.employeeCount}} employees, how many were offered a raise during X time period?'
        placeholder: 'Number of employees'
    },
    classifyEmployeeWages: {
        label: 'In looking at wages/salaries, how would you classify your employees as of {{it.targetPeriod.end}}?',
        description:
            'Expand each wage/salary tiers below for which you have employees whose pay falls within the bounds described. Enter the total number of employees for that tier as well as the number of full-time/part-time.'
    },
    fullTimeEmployeeCount: {
        label: 'Of those {{it.employeeCount}} employees, how many are full-time?'
    },
    partTimeEmployeeCount: {
        label: 'Of those {{it.employeeCount}} employees, how many are part-time?'
    },
    wereContractorsHired: {
        label: 'Did you hire any contractors for your business between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?'
    },
    contractorsWithHourlyRateCount: {
        label: 'Of those contractors, how many were paid on an hourly basis?'
    },
    contractorsPaidPerJobCount: {
        label: 'Of those contractors, how many were paid per job?'
    },
    classifyContractorsPay: {
        label: 'In looking at hourly pay, how would you classify your contractors as of {{it.targetPeriod.end}}?'
    },
    employeesFullPartTime: {
        label: 'Of those employees, how many are full-time/part-time?',
        description: 'Full-time is defined as 32 hours/week or more.'
    },
    contractorsFullPartTime: {
        label: 'Of those contractors, how many are full-time/part-time?'
    },
    personalPay: {
        label: 'How much income or salary ("take-home pay") did you pay yourself from the business between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?'
    },
    personalWeeklyHours: {
        label: 'In an average week, how many hours did you typically work at the business between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?',
        placeholder: 'Number of hours'
    },
    personalMonthsWorkedPerYear: {
        label: 'How many months of the year did you work at your business between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?',
        placeholder: 'Number of months'
    },
    personalPayMeetExpectations: {
        label: 'How well would you say the amount you paid yourself from your business met your expectations?'
    },
    reasonExpectationsNotMet: {
        label: 'What is the main reason you feel your expectations were not met?'
    },
    expectationNotMetDescription: {
        label: 'If you selected "other," please describe.'
    },
    primaryOrSupplementalSourceOfIncome: {
        label: 'How did your business contribute to your household’s overall income from {{it.targetPeriod.start}} to {{it.targetPeriod.end}}?'
    },
    sharedIncomeOrExpensesCount: {
        label: 'Counting yourself, your spouse/partner, and children, how many people lived with you and shared income or expenses between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?',
        description:
            'Please do not include roommates or renters who do not share income or expenses, but do include extended family members or significant others if they do share income and expenses. If this changed during the year, please indicate the number that lasted for the longest period of time.',
        invalidMessages: {
            numberTooHigh: 'Value may not exceed 25.'
        }
    },
    publicAssistanceReceived: {
        label: 'Between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}, did you receive public assistance (e.g. TANF, SNAP, Section 8, Medicaid (AHCCCS), etc.) ',
        description:
            'We define "Public Assistance" as services available to individuals whose income is below a certain threshold. Please do not consider benefits that are NOT determined based on income levels, such as FEMA, Medicare, etc.'
    },
    totalHouseholdIncome: {
        label: 'What was your total household income from {{it.targetPeriod.start}} to {{it.targetPeriod.end}} (including income from business and other jobs)?'
    },
    householdIncomeComparison: {
        label: 'Please compare your total household income to the prior year. Was your household income from {{it.targetPeriod.start}} to {{it.targetPeriod.end}}…'
    },
    ableToSaveMoney: {
        label: 'Were you able to save any money between {{it.targetPeriod.start}} and {{it.targetPeriod.end}}?'
    },
    costOfGoods: {
        label: 'Cost of Goods'
    },
    ownerName: {
        label: "What is Owner/Executive Team Member #1's Name?"
    },
    ownerRace: {
        label: "What is Owner #1's Race/Ethnicity?"
    },
    ownerGender: {
        label: "What is Owner #1's Gender?"
    },
    ownerVeteran: {
        label: 'Is Owner #1 a Veteran?'
    },
    ownerDisability: {
        label: 'Does Owner #1 have a Disability?'
    },
    costTable: {
        invalidMessages: {
            totalTooLow: 'Total amount cannot be less than the sum of the amounts listed.'
        }
    },
    employeeCountWageTier: {
        label: 'How many employees in this wage range?'
    },
    contractorCountWageTier: {
        label: 'How many contractors in this wage range?'
    },
    employeeCountWageTier0: {
        label: 'How many employees make less than $13.85/hr?'
    },
    employeeCountWageTier1: {
        label: 'How many employees make $13.85 - $17.99/hr (~$28,808 - $37,439, annually)?'
    },
    employeeCountWageTier2: {
        label: 'How many employees make $18.00 - $21.99/hr (~$37,440 - $45,759, annually)?'
    },
    employeeCountWageTier3: {
        label: 'How many employees make $22.00 - $25.99/hr (~$45,760 - $54,079, annually)?'
    },
    employeeCountWageTier4: {
        label: 'How many employees make $26.00 - $32.99/hr (~$54,080 - $68,639, annually)?'
    },
    employeeCountWageTier5: {
        label: 'How many employees make $33.00 - $47.99/hr (~$68,640 - $99,839, annually)?'
    },
    employeeCountWageTier6: {
        label: 'How many employees make $48.00/hr (~$99,840, annually) or more?'
    },
    employeeCountWageTierUnder: {
        label: 'How many employees make less than <strong>{{hourly}}</strong>/hr?'
    },
    employeeCountWageTierOver: {
        label: 'How many employees make <strong>{{hourly}}/hr</strong> (<strong>~{{annual}}</strong>, annually) or more?'
    },
    employeeCountWageTierBetween: {
        label: 'How many employees make <strong>{{hourlyLow}}</strong> - <strong>{{hourlyHigh}}</strong>/hr (~<strong>{{annuallyLow}}</strong> - <strong>{{annuallyHigh}}</strong>, annually)?'
    },
    tierSectionUnder: {
        label: 'Less than {{hourly}}/hr'
    },
    tierSectionOver: {
        label: '{{hourly}}/hr (~{{annual}}, annually) or more'
    },
    tierSectionOverHourOnly: {
        label: '{{hourly}}/hr or more'
    },
    tierSectionBetween: {
        label: '{{hourlyLow}} - {{hourlyHigh}}/hr (~{{annuallyLow}} - {{annuallyHigh}}, annually)'
    },
    tierSectionBetweenHourOnly: {
        label: '{{hourlyLow}} - {{hourlyHigh}}/hr'
    },
    wageRanger: {
        invalidMessages: {
            sumTotal: 'Sum of those in salary ranges does not equal the total number of workers stated.',
            wageTierSum: 'Sum of full and part time does not equal the total.'
        }
    },
    common: {
        description: {
            backendCalculation: 'This value cannot be manually edited.'
        },
        invalidMessages: {
            exceedsEmployeeCount: 'Amount cannot be more than the total number of employees',
            monthTooHigh: 'Value cannot be greater than 12',
            hoursInWeekTooHigh: 'Value cannot be greater than 168',
            numberTooLow: 'Value cannot be less than 0',
            invalidNumber: 'Please enter a valid number',
            mustProvideOneFinancial: 'Please provide at least one value. Enter $ 0.00 if none are relevant.'
        }
    },
    isEnrolled: {
        label: 'Enrolled'
    },
    userRole: {
        label: 'Role'
    },
    profitLoss: {
        label: 'Profit & Loss Statement'
    },
    profitLossIncomeTable: {
        label: 'Income'
    },
    profitLossExpensesTable: {
        label: 'Expenses'
    },
    profitLossGrossReceipt: {
        label: 'Gross receipt of sales'
    },
    profitLossReturns: {
        label: 'Returns and allowances'
    },
    profitLossCostOfGoods: {
        label: 'Cost of goods sold'
    },
    profitLossGrossProfit: {
        label: 'Gross profit'
    },
    profitLossOtherIncome: {
        label: 'Other income'
    },
    profitLossGrossIncome: {
        label: 'Gross income'
    },

    profitLossExpensesAdvertising: {
        label: 'Advertising'
    },
    profitLossExpensesAuto: {
        label: 'Auto'
    },
    profitLossExpensesContractLabor: {
        label: 'Contract Labor'
    },
    profitLossExpensesDepreciation: {
        label: 'Depreciation'
    },
    profitLossExpensesInterest: {
        label: 'Interest'
    },
    profitLossExpensesInsurance: {
        label: 'Insurance'
    },
    profitLossExpensesLegal: {
        label: 'Legal and professional services'
    },
    profitLossExpensesOffice: {
        label: 'Office expenses'
    },
    profitLossExpensesRent: {
        label: 'Rent or lease'
    },
    profitLossExpensesRepairs: {
        label: 'Repairs and maintenance'
    },
    profitLossExpensesSupplies: {
        label: 'Supplies'
    },
    profitLossExpensesTax: {
        label: 'Tax'
    },
    profitLossExpensesTravel: {
        label: 'Travel'
    },
    profitLossExpensesMeals: {
        label: 'Meals'
    },
    profitLossExpensesUtilities: {
        label: 'Utilities'
    },
    profitLossExpensesWages: {
        label: 'Wages'
    },
    profitLossExpensesOther: {
        label: 'Other expenses'
    },
    profitLossExpensesTotal: {
        label: 'Total expenses'
    },
    profitLossNetProfit: {
        label: 'Net profit (or loss)',
        tooltip: 'Gross income minus total expenses'
    },
    profitLossNetProfitTable: {
        label: ''
    },
    balanceSheetTableEquityTable: {
        label: ''
    },
    balanceSheetAssets: {
        label: 'Assets',
        description:
            'Please provide the value of your business assets as of the last day of {{it.targetPeriod.end}}. Assets include cash balances in bank and investment accounts, accounts receivable (money owed to you), inventory, furniture, vehicles, equipment, buildings, land, and any other property owned by your business.'
        // description:
        //     'Please provide the value of your business assets as of the last day of the previous year. Assets include cash balances in bank and investment accounts, accounts receivable (money owed to you), inventory, furniture, vehicles, equipment, buildings, land, and any other property owned by your business.'
    },
    balanceSheetLiabilities: {
        label: 'Liabilities',
        description:
            'Please provide the total value of your business liabilities, or amounts owed to others, as of the last day of {{it.targetPeriod.end}}. Liabilities include accounts payable (amounts owed to suppliers or vendors), customer prepayments, short-term and long-term loans, credit card balances, taxes payable, and any other financial obligations your business is responsible for.'
    },
    balanceSheetEquity: {
        label: 'Equity'
    },
    balanceSheetTable: {
        label: 'Balance Sheet'
    },
    financialsEmployeeCount: {
        label: 'Number of employees as of the last day of {{it.targetPeriod.end}}',
        // label: 'Current number of employees',
        description: 'Total Number of Employees: Include all individuals employed, regardless of their work schedule.'
    },
    financialsEmployeeFullTime: {
        label: 'Full-time equivalents',
        description:
            'A full-time worker works 40 hours per week. If you employ people on a part-time basis, translate their hours to full time equivalents (FTEs) (i.e. If two part-time employees each work 30 hours per week, the full time equivalent is 1.5. 60 total hours divided by 40 hours = 1.5 FTEs)'
    }
};
